import React, { useEffect } from "react";
import { Avatar, Card, Progress } from "antd";
import { connect } from "react-redux";
import { Trophy } from "lucide-react";
import { getEmployeeRewardLeaderboard } from "../../../../../redux/employeereward/employeeRewardState";

const Leaderboards = ({ recordList = [], pagination, doSearch }) => {

  useEffect(() => {
    doSearch({
      paginate: pagination?.per_page || 10,
      view: "leaderboard"
    });
  }, [pagination?.per_page]);

  const sortedData = Array.isArray(recordList)
    ? [...recordList].sort(
        (a, b) => (b.total_points || 0) - (a.total_points || 0)
      )
    : [];

  const highestPoints =
    sortedData.length > 0
      ? sortedData[0]?.total_points || 1
      : 1;

  return (
    <div className="flex flex-col gap-3">

      {sortedData.map((item, index) => {

        const rank = index + 1;

        const percentage =
          ((Number(item?.total_points) || 0) /
            (Number(highestPoints) || 1)) * 100;

        return (
          <Card
            key={item?.erw_employee_id || index}
            className={`rounded-xl dark-mode-card ${getRankStyles(rank).card}`}
          >
            <div className="flex justify-between items-center">

              <div className="flex justify-between items-center gap-3">

                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold ${getRankStyles(rank).rank}`}
                >
                  #{rank}
                </div>

                <Avatar
                  size={40}
                  className="bg-gradient-to-br from-emerald-500 to-violet-500 overflow-hidden"
                >
                  {item?.employee_initials}
                </Avatar>

                <div className="flex-1">
                  <p className="inline-flex gap-2 font-semibold text-sm title-text">
                    {item?.employee_name}
                    <Trophy className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                  </p>

                  <p className="text-[11px] muted-text">
                    {item?.employee_position}
                  </p>
                </div>

              </div>

              <div className="flex flex-col items-end">
                <span className="rounded-xl border px-2 py-0.5 text-[11px] font-semibold bg-gradient-to-r from-emerald-500 to-purple-500 title-text">
                  {item?.total_points || 0} credits
                </span>

                <span className="text-[11px] muted-text mt-1">
                  {item?.department_name}
                </span>
              </div>

            </div>

            {percentage >= 0.1 && (
              <div className="mt-3">
                <Progress
                  percent={parseFloat(percentage.toFixed(1))}
                  showInfo={false}
                  strokeColor="#22c55e"
                  trailColor="rgba(34, 197, 94, 0.2)"
                  strokeWidth={8}
                  strokeLinecap="round"
                />
              </div>
            )}

          </Card>
        );
      })}
    </div>
  );
};

const getRankStyles = (rank) => {
  switch (rank) {
    case 1:
      return {
        card:
          "border-2 border-yellow-300 bg-gradient-to-r from-yellow-50 to-white py-1 dark:from-yellow-900 dark:to-white/5",
        rank:
          "bg-gradient-to-br from-yellow-400 to-yellow-600 text-white"
      };

    case 2:
      return {
        card:
          "border-2 border-yellow-300 bg-gradient-to-r from-yellow-50 to-white py-0.5 dark:from-yellow-900 dark:to-white/5",
        rank:
          "bg-gradient-to-br from-gray-400 to-gray-600 text-white"
      };

    case 3:
      return {
        card:
          "border-2 border-yellow-300 bg-gradient-to-r from-yellow-50/50 to-white dark:from-yellow-900 dark:to-white/5",
        rank:
          "bg-gradient-to-br from-orange-400 to-orange-600 text-white"
      };

    default:
      return {
        card: "border border-slate-200 bg-card",
        rank: "bg-gradient-to-br from-slate-200 to-slate-400"
      };
  }
};

const mapStateToProps = (state) => ({
  recordList: state.employeeReward.leaderboardList?.items,
  pagination: state.employeeReward.leaderboardList?.pagination
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) =>
    dispatch(getEmployeeRewardLeaderboard(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(Leaderboards);